<template>
  <div class="bk bk-overlay-header">
    <ItemIcon v-if="bundle" :bundle="bundle" />
    <div v-else class="bk-blokkli-item-icon">
      <Icon :name="icon" />
    </div>
    <h3>{{ title }}</h3>
    <button @mousedown.capture.stop="$emit('close')">
      <Icon name="close" />
    </button>
  </div>
</template>

<script setup>
import { ItemIcon, Icon } from "#blokkli/components";
defineProps({
  bundle: { type: String, required: false, default: "" },
  icon: { type: null, required: false, default: "form" },
  title: { type: String, required: true }
});
defineEmits(["close"]);
</script>

<script>
export default {
  name: "FormOverlayHeader"
};
</script>
